import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

// Once a user has signed in through the SSO flow (sso_user cookie, set by
// sso-landing.component.ts), they're restricted to the SSO landing page,
// the appointments page, and the consultation booking flow reached from an
// SSO service card - the rest of the app (messages, wallet, myHealth,
// savings, myAccount, the full service tile grid, etc.) isn't part of that
// simplified experience and stays off-limits.
export const SSO_ALLOWED_PREFIXES = [
  '/sso',
  '/home/appointments',
  '/home/servicePage/advancedConsultation'
];

export function isSsoAllowedUrl(fullUrl: string): boolean {
  const url = (fullUrl || '').split('?')[0];
  return SSO_ALLOWED_PREFIXES.some(prefix => url === prefix || url.indexOf(prefix + '/') === 0);
}

@Injectable({ providedIn: 'root' })
export class SsoRestrictGuard implements CanActivateChild {
  constructor(private cookie: CookieService, private router: Router) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.cookie.get('sso_user') !== 'true') {
      return true;
    }

    if (isSsoAllowedUrl(state.url)) {
      return true;
    }

    this.router.navigate(['/sso']);
    return false;
  }
}
